<section class="w-100 h-100 overflow-hidden splash-container flex flex-column align-items-center justify-content-center" [class.splash-container-hidden]="!isShowSplashScreen">
  <app-octa-loader [color]="selectedTheme === theme.LIGHT ? '#5400BD' : '#FFFFFF'" [size]="120"></app-octa-loader>
  <div class="overlay" [class.overlay-hidden]="!isShowSplashScreen"></div>
</section>